import { useTranslation } from "react-i18next";
import { AppShell } from "../../components/layout/AppShell";
import { ScopeBar } from "../../components/data/ScopeBar";
import { PurchaseNav } from "./PurchaseNav";
import { BranchScopeProvider, useBranchScope } from "./branchScope";

const ScopeRow = () => {
  const { branchId, setBranchId } = useBranchScope();
  return <ScopeBar value={branchId} onChange={setBranchId} testid="purchase-scope" />;
};

// قوقعة كل شاشات المشتريات: رأس + نطاق الفرع + تبويبات القسم.
export const PurchaseShell = ({ titleKey, actions, children }) => {
  const { t } = useTranslation();

  return (
    <AppShell title={t("purchases.title")} subtitle={t(`purchases.tabs.${titleKey}`)}
              actions={actions}>
      <BranchScopeProvider>
        <div className="grid gap-4">
          <ScopeRow />
          <PurchaseNav />
          {children}
        </div>
      </BranchScopeProvider>
    </AppShell>
  );
};
